import { parseFromFile, workbookToBuffer } from '@/lib/excel';
import { processContractReleaseReport } from './utils/contractReleaseProcessor';

export async function runReport(file: File) {
    const report = (await parseFromFile(file) as any).data.excelJsWorkbook;

    const reportWorkbook = await processContractReleaseReport(report);

    return {
        buffer: await workbookToBuffer(reportWorkbook)
    };
}
